module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/4mill-active-fd3d307359c23e0a2517c9c34fe894cc.png";